import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DeleteOutlined, ReloadOutlined, EyeOutlined } from '@ant-design/icons';
import { Spin, Typography } from 'antd';
import { AttachmentItem } from './style';
import { FileIcon } from '../../../fileIcon/fileIcon';
import { ActionButton } from '../style';
import constants from '../../../../config/api/constants';

const AttachmentListItem = ({ attachmentData, readOnly, getRemoveItemHandler, getRetryUploadItemHandler }) => {
  const [objectUrl, setObjectUrl] = useState(null);

  useEffect(() => {
    if (attachmentData.url || !attachmentData.file) {
      setObjectUrl(null);
      return;
    }
    const url = URL.createObjectURL(attachmentData.file);
    setObjectUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [attachmentData.file, attachmentData.url]);

  const previewUrl = attachmentData.url 
    ? `${constants.s3UrlPath}/${attachmentData.url}`
    : objectUrl;

  return (
    <Spin spinning={attachmentData.loading}>
      <li>
        <AttachmentItem>
          <FileIcon className="attachment-file-icon" filename={attachmentData.filename} size="60px" />
          <Typography.Text
            type={attachmentData.hasError ? 'danger' : 'default'}
            className="attachment-filename"
          >
            {attachmentData.filename}
          </Typography.Text>
          {attachmentData.hasError ? (
            <ActionButton
              className="attachment-action"
              onClick={getRetryUploadItemHandler(attachmentData)}
              icon={<ReloadOutlined />}
            />
          ) : (
            <a href={previewUrl} target="__blank" rel="noopener noreferrer">
              <ActionButton
                className="attachment-action"
                icon={<EyeOutlined />}
              />
            </a>
          )}
          {!readOnly ? (
            <ActionButton
              className="attachment-action"
              onClick={getRemoveItemHandler(attachmentData)}
              icon={<DeleteOutlined />}
            />
          ) : null}
        </AttachmentItem>
      </li>
    </Spin>
  );
};

export const AttachmentList = ({ defaultValue = [], readOnly, getRemoveItemHandler = ()=>{},getRetryUploadItemHandler= ()=>{} }) => {
  return (
    <ul>
      {defaultValue.map(attachmentData => (
        <AttachmentListItem
          key={attachmentData.id}
          attachmentData={attachmentData}
          readOnly={readOnly}
          getRemoveItemHandler={getRemoveItemHandler}
          getRetryUploadItemHandler={getRetryUploadItemHandler}
        />
      ))}
    </ul>
  );
};

AttachmentList.propTypes = {
  readOnly: PropTypes.bool,
  defaultValue: PropTypes.arrayOf(
    PropTypes.shape({
      fileName: PropTypes.string, // this naming case come from tapptus v1
      url: PropTypes.string,
    }),
    ),
  getRemoveItemHandler: PropTypes.func,
  getRetryUploadItemHandler: PropTypes.func,
};

AttachmentListItem.propTypes = {
  readOnly: PropTypes.bool,
  attachmentData: PropTypes.shape({
    id: PropTypes.string,
    filename: PropTypes.string,
    url: PropTypes.string,
    file: PropTypes.instanceOf(File),
    loading: PropTypes.bool,
    hasError: PropTypes.bool,
  }),
  getRemoveItemHandler: PropTypes.func,
  getRetryUploadItemHandler: PropTypes.func,
};